import { FormEvent, useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { Search } from "lucide-react";

interface HeaderSearchProps {
  className?: string;
}

export const HeaderSearch = ({ className = "" }: HeaderSearchProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const [query, setQuery] = useState("");

  useEffect(() => {
    if (location.pathname.startsWith("/products")) {
      setQuery(searchParams.get("q") ?? "");
    } else {
      setQuery("");
    }
  }, [location.pathname, searchParams]);

  const onSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const q = query.trim();
    navigate(q ? `/products?q=${encodeURIComponent(q)}` : "/products");
  };

  return (
    <form
      onSubmit={onSubmit}
      role="search"
      className={`relative ${className}`}
      data-testid="header-search"
    >
      <Search
        size={16}
        className="absolute left-3 top-1/2 -translate-y-1/2 text-vg-gray pointer-events-none"
        aria-hidden
      />
      <input
        type="search"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder="Search products…"
        className="w-full h-10 pl-9 pr-3 border border-black/10 bg-white/80 text-sm text-vg-ink placeholder:text-vg-gray focus:outline-none focus:ring-1 focus:ring-vg-navy focus:border-vg-navy"
        aria-label="Search products"
        data-testid="header-search-input"
      />
    </form>
  );
};

export default HeaderSearch;
